import {
	CheckCircleOutlined,
	ExclamationCircleOutlined,
	FieldTimeOutlined,
	LoadingOutlined,
	StarFilled,
	StarOutlined,
	SyncOutlined,
} from '@ant-design/icons';
import { Avatar, Button, Flex, Space, Tooltip, Typography } from 'antd';
import { SortOrder } from 'antd/es/table/interface';
import Link from 'antd/es/typography/Link';

import { QACollectionItem } from '@/api/monitor_collections';
import prepareDate from '@/lib/helpers/prepareDate';

const columns = [
	{
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		hidden: true,
		render: (_: any, record: QACollectionItem) => {
			return <p title={'' + record?.id}>{record.title}</p>;
		},
	},
	{
		title: 'Date/time',
		dataIndex: 'created_at',
		key: 'created_at',
		sorter: true,
		sortDirections: ['ascend', 'descend', 'ascend'] as SortOrder[],
		width: 80,
		// flex: true,
		// ellipsis: true,
		// hidden: true,
		render: (_: any, record: QACollectionItem) => {
			return (
				<>
					{record?.created_at
						? prepareDate('' + record?.created_at)
						: 'no date'}
				</>
			);
		},
	},
	{
		title: 'Title',
		dataIndex: 'title',
		key: 'title',
		width: 100,
		ellipsis: true,
		render: (_: any, record: QACollectionItem) => {
			const preparedTitle =
				record?.title?.length > 90
					? (record?.title).slice(0, 90) + '...'
					: record?.title;

			return <Space size={[4, 1]}>{preparedTitle}</Space>;
		},
	},
	{
		title: 'Description',
		dataIndex: 'description',
		key: 'description',
		width: 200,
		ellipsis: true,
		render: (_: any, record: QACollectionItem) => {
			return <Space size={[8, 1]}>{record?.description || ''}</Space>;
		},
	},
	{
		title: 'Prompts',
		dataIndex: 'prompt_count',
		key: 'prompt_count',
		width: 100,
		ellipsis: true,
		render: (_: any, record: QACollectionItem) => {
			return <Space size={[8, 1]}>{record?.prompt_count || 0}</Space>;
		},
	},
	{
		title: 'Favourite',
		dataIndex: 'favourite',
		key: 'favourite',
		width: 45,
		ellipsis: true,
		render: (_: any, record: QACollectionItem) => {
			return (
				<Flex style={{ width: '100%' }} justify="center" align="center">
					{record?.favourite ? (
						<StarFilled style={{ color: '#fc941c', fontSize: '16px' }} />
					) : null}
				</Flex>
			);
		},
	},
];

export { columns };
